import React from "react";
import DeployHeroSection from "./deployHerosection/DeployHerosection";
import DeployTestimonial from "./deployTestimonial/DeployTestimonial";
import DeployService from "./deployService/DeployService";
import DeployFaster from "./deployFaster/DeployFaster";
import DeployChoose from "./deployChoose/DeployChoose";
import DeployApproach from "./deployApproach/DeployApproach";
import DeployOffer from "./deployOffer/DeployOffer";
import DeployDelivery from "./deployDelivery/DeployDelivery";
import DeployContinuous from "./deployContinuous/DeployContinuous";

export default function Deploy() {
  return (
    <div id="deploy">
      <DeployHeroSection />
      <DeployContinuous/>
      <DeployDelivery/>
      <DeployOffer/>
      <DeployApproach/>
      <DeployChoose/>
      <DeployFaster/>
      <DeployTestimonial/>
      <DeployService/>
    </div>
  );
}
